

import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {

  1: {
    unit: 'Review 4',
    id: 'SB4-PV4-P93-E1',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    fontSize: 22,
    exerciseKey: 'img/FriendsPlus/Page93/E1/Key/answerKey.png',
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page93/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page93/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page93/E1/3.jpg', input: true, answer: "weren't" },
        { url: 'img/FriendsPlus/Page93/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page93/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page93/E1/6.jpg', input: true, answer: "were" },
        { url: 'img/FriendsPlus/Page93/E1/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page93/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page93/E1/9.jpg', input: true, answer: "was" },
        { url: 'img/FriendsPlus/Page93/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page93/E1/11.jpg', input: true, answer: "wasn't/were" },
        { url: 'img/FriendsPlus/Page93/E1/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page93/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page93/E1/14.jpg', input: true, answer: "was" },
        { url: 'img/FriendsPlus/Page93/E1/15.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page93/E1/16.jpg' },
      ],



    ]
  },


  2: { // Exercise num
    unit: 'Review 4',
    id: 'SB4-PV4-P93-E2',
    audio: '',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page93/E2/Key/answerKey.png',
    inputSize: 165,
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page93/E2/1.jpg' /> </div>

          <div style=" position: absolute; top: 92px; left: 548px; "><input id='0' /></div>
          <div style=" position: absolute; top: 128px; left: 548px; "><input id='1' /></div>
          <div style=" position: absolute; top: 165px; left: 548px; "><input id='2' /></div>
          <div style=" position: absolute; top: 202px; left: 547px; "><input id='3' /></div>
          <div style=" position: absolute; top: 239px; left: 547px; "><input id='4' /></div>

        </div>
        `,
        answer: [
          "didn't have",
          "had",

          "didn't have",
          "had",
          "didn't have",
        ],
      },
    ],
  },
  3: { // Exercise num
    unit: 'Review 4',
    id: 'SB4-PV4-P93-E3',
    audio: '',
    video: '',
    component: T6,
    stylesTextInput: { backgroundColor: 'transparent', border: 'none', padding: 0 },
    exerciseKey: 'img/FriendsPlus/Page93/E3/Key/answerKey.png',
    inputSize: 36,
    questionImage: [],
    questions: [
      {
        title: `
        <div style=" position: relative; ">
          <div> <img src='img/FriendsPlus/Page93/E3/1.jpg' /> </div>

          <div style=" position: absolute; top: 254px; left: 518px; "><input id='0' /></div>
          <div style=" position: absolute; top: 254px; left: 809px; "><input id='1' /></div>
          <div style=" position: absolute; top: 254px; left: 850px; "><input id='2' /></div>
          <div style=" position: absolute; top: 523px; left: 225px; "><input id='3' /></div>
          <div style=" position: absolute; top: 554px; left: 348px; "><input id='4' /></div>
          <div style=" position: absolute; top: 522px; left: 742px; "><input id='5' /></div>


        </div>
        `,
        answer: [
          "ee",
          "i",
          "e",
          "igh",
          "ea",
          "y",
        ],
      },
    ],
  },




}
export default json;
